// extracted by mini-css-extract-plugin
module.exports = {"adminTask":"styles_adminTask__1_orW","statusIcon":"styles_statusIcon__2OqxC","info":"styles_info__bJPB_","name":"styles_name__1NLp1"};